module.exports = __webpack_public_path__ + "img/search-icon.b74c034b.svg";